<template>
	<small-modal @close="close" prevent-mask-close>
		<template #title>Wachtwoord aanvragen</template>
		<template #body>
			<feedback-banner :purpose="PurposeOptions.danger" class="feedback-banner-overwrite">
				<div id="feedback-info">
					<p v-if="feedback">{{feedback}}</p>
				</div>
			</feedback-banner>
			<p class="auth-header-text">Er is een mail gestuurd met een tijdelijke code.<br>Deze code is eenmalig en maximaal 15 minuten geldig.</p>
			<div class="form">
				<authcode-input :amount-of-inputs="6" class="authcode-wrapper" @keydown.enter="focusPasswordInput" @authCode="codeToUpper"/>
				<password-input :force-focus="forceFocus" feedback-teleport-anchor="feedback-info" @nextAction="requestNewPassword" @validatedPassword="validatedPassword"/>
			</div>
		</template>
		<template #footer>
			<simple-button :disabled="!password || !code" :size="SizeOptions.L" class="full-width-button" @click="requestNewPassword">Opslaan</simple-button>
			<simple-button :emphasis="EmphasisOptions.medium" :size="SizeOptions.L" class="full-width-button" @click="close">Annuleren</simple-button>
		</template>
		<wait-animation v-if="isLoading" :context="ContextOptions.content"/>
	</small-modal>
</template>
<script>
import {SmallModal} from "@datapas/vue-modal";
import {ContextOptions, FeedbackBanner, PurposeOptions, WaitAnimation} from "@datapas/vue-feedback";
import {SizeOptions, TextInput} from "@datapas/vue-input";
import {EmphasisOptions, SimpleButton} from "@datapas/vue-button";

import PasswordInput from "./PasswordInput.vue";

import requestPasswordChange from "../graphql/mutations/requestPasswordChange.graphql";
import AuthcodeInput from "./AuthCodeInput.vue";

export default {
	name: "RequestPasswordChangeModal",
	components: {
		AuthcodeInput,
		FeedbackBanner,
		PasswordInput,
		SmallModal,
		WaitAnimation,
		TextInput,
		SimpleButton
	},
	props: {
		userName: {
			type: String,
			required: true
		}
	},
	emits: ['close'],
	setup() {
		return {
			ContextOptions,
			PurposeOptions,
			EmphasisOptions,
			SizeOptions
		};
	},
	data() {
		return {
			isLoading: false,
			code: null,
			password: null,
			feedback: null,
			forceFocus: 0,
		};
	},
	methods: {
		close() {
			this.$emit('close');
		},
		requestNewPassword() {
			this.isLoading = true;
			this.$graphql.query(requestPasswordChange, {
				passwordInput: {
					login: this.userName,
					code: this.code,
					password: this.password
				}
			}).then(() => {
				this.isLoading = false;
				this.$toaster.success('Wachtwoord is successvol aangepast. U kunt nu inloggen');
				this.close();
			}).catch((result) => {
				this.feedback = this.$graphql.getFeedbackFromErrors(result.errors).join("\n") || 'Er is iets misgegaan met het aanmaken het nieuwe wachtwoord. Neem contact op met datapas';
				this.isLoading = false;
			});
		},
		validatedPassword(value) {
			this.password = value;
		},
		codeToUpper(value) {
			this.code = value?.toUpperCase() ?? null;
		},
		focusPasswordInput() {
			this.forceFocus++;
		}
	}
};

</script>

<style scoped lang="scss">
@use "@datapas/scss-framework/src/vars.scss";
@use "@datapas/scss-framework/src/form.scss";
@use "../scss/auth.scss";

.feedback-banner {
	margin-bottom: vars.$CONTENT-SPACING;
}

.feedback-banner-overwrite {
	display: none;
	margin-top: vars.$CONTENT-SPACING;
	margin-bottom: vars.$CONTENT-SPACING;
	&:has(#feedback-info > *) {
		display: block;
	}
}
:deep(.title) {
	font-size: auth.$AUTH_TITLE_FONT_SIZE;
}

</style>